import classNames from "classnames";
import SMaxWidthContainer, { type SMaxWidthContainerProps } from "components/framework/SMaxWidthContainer";
import SSectionHeader, { type SectionHeaderProps } from "components/framework/SSectionHeader";
import { type ComponentProps } from "react";
import styles from "./SMaxWidthMovieGrid.module.css";

//#region [Props]
export type SGridProps = {
    $columns?: number;
} & SMaxWidthContainerProps;
//#endregion


export default function SMaxWidthMovieGrid({ $columns, className, style, ...rest }: SGridProps) {
    const _style = { "--columns": $columns ?? 3, ...style };
    return <SMaxWidthContainer className={classNames(styles.SMaxWidthMovieGrid, className)} style={_style} {...rest} />
}

export type SMaxWidthMovieGridHeaderProps = {
    $columns?: number;
} & SectionHeaderProps;



export function SMaxWidthMovieGridHeader({ $columns, className, style, ...rest }: SMaxWidthMovieGridHeaderProps) {
    const _style = { "--columns": $columns ?? 3, ...style };
    return <SSectionHeader className={classNames(styles.SFullGridRow, className)} style={_style} {...rest} />
}

type SMovieCellProps = ComponentProps<"article">;

export function SMovieCell({ className, children }: SMovieCellProps) {
    return <article className={classNames(styles.SMovieCell, className)}>{children}</article>
}
